import React from "react";
import { DicomViewer } from "../utilities/dicom-viewer";
import { useParams } from "react-router-dom";

const DicomViewerPage = () => {
	let { tid: tenantId, uid: studyUIdStr, mod: mod } = useParams();
	let studyUIds = studyUIdStr.split(';');
	const viewerMode =
		new URLSearchParams(window.location.search).get("viewer") ?? "ohif-v3";

	return (
		<DicomViewer
			mode={viewerMode}
			tenantId={parseInt(tenantId)}
			studyUids={studyUIds}
			modality={mod}
			showMainImages={true}
		/>
	);
};

export default DicomViewerPage;
